import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=99d73c90&"
import script from "./Servicio.vue?vue&type=script&lang=js&"
export * from "./Servicio.vue?vue&type=script&lang=js&"
import style0 from "./Servicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports